import { httpRequest } from "@services/http";
import type { KeyDate } from "@models/keyDate.model";

const BASE = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/`;

/*
    Key dates against a campaign rather than an objective (MPN-2185).

    The server falls back to the objective's key dates while they are still moving, so this
    returns the right rows for a campaign whether or not the backfill has reached it. The
    objective-scoped calls on EngagementService stay until `KeyDate.objective` goes away.
*/
export class KeyDateService {
  async listForCampaign(launchId: number) {
    return await httpRequest<KeyDate[]>(`${BASE}launches/${launchId}/key-dates/`, {
      method: "GET",
    });
  }

  async createForCampaign(launchId: number, payload: Partial<KeyDate>) {
    return await httpRequest<KeyDate>(`${BASE}launches/${launchId}/key-dates/`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  async updateForCampaign(launchId: number, keyDateId: number, payload: Partial<KeyDate>) {
    return await httpRequest<KeyDate>(
      `${BASE}launches/${launchId}/key-dates/${keyDateId}/`,
      { method: "PUT", body: JSON.stringify(payload) },
    );
  }

  async deleteForCampaign(launchId: number, keyDateId: number) {
    await httpRequest(`${BASE}launches/${launchId}/key-dates/${keyDateId}/`, {
      method: "DELETE",
    });
  }
}
